import apiEndPoints from "../../routeConfig";
import { ApiService } from "../../../service/api.service";
import { attempt } from "../../../service/apiResult";

const apiService = new ApiService();

export const cropsCreateUpdate = async (data, editMode, id) => {
  try {
    let url;
    if (editMode === true) {
      url = `${apiEndPoints.cropsCreateOrUpdate}/${id}`;
      const response = await apiService.update(url, data);
      return response;
    } else {
      url = `${apiEndPoints.cropsCreateOrUpdate}`;
      const response = await apiService.post(url, data);
      return response;
    }
  } catch (error) {
    return { success: false, message: error.message || 'Failed to save crop', data: null };
  }
};

export const getAllCrops = async (page = 0, size = 10) => {
  try {
    const response = await apiService.get(`${apiEndPoints.getAllCrops}?page=${page}&size=${size}`);
    return response || { data: { content: [], totalElements: 0 } };
  } catch (error) {
    return { data: { content: [], totalElements: 0 } };
  }
};

export const cropsGetById = async (id) => {
  try {
    const response = await apiService.get(`${apiEndPoints.cropsGetById}/${id}`);
    return response || { data: {} };
  } catch (error) {
    return { data: {} };
  }
};

export const deleteCrops = async (id) =>
  attempt(() => apiService.patch(`${apiEndPoints.deleteCrops}/${id}/status/DELETED`, ''));

export const patchCropsApi = async (id, statusUpdate) =>
  attempt(() => apiService.patch(`${apiEndPoints.patchCropsApi}/${id}/status/${statusUpdate}`, ''));

export const linkCropToIntegrator = async (cropId, ecosystemIntegratorId) => {
  try {
    const response = await apiService.post(
      `${apiEndPoints.cropsCreateOrUpdate}/${cropId}/integrators`,
      { ecosystemIntegratorId }
    );
    return response;
  } catch (error) {
    return { success: false, message: error.message || 'Failed to link integrator' };
  }
};

export const listIntegratorsByCrop = async (cropId) => {
  try {
    const response = await apiService.get(`${apiEndPoints.cropsCreateOrUpdate}/${cropId}/integrators`);
    console.log('Raw response:', response);

    // Handle different response formats
    let mappings = [];
    if (Array.isArray(response)) {
      mappings = response;
    } else if (response?.data && Array.isArray(response.data)) {
      mappings = response.data;
    } else if (response?.data?.content && Array.isArray(response.data.content)) {
      mappings = response.data.content;
    }

    console.log('Linked integrators mappings:', mappings);

    if (mappings.length === 0) {
      return [];
    }

    // Enrich with integrator names
    const enrichedMappings = await Promise.all(
      mappings.map(async (mapping) => {
        try {
          const integratorUrl = `${apiEndPoints.ecosytemIntegatorGetById}/${mapping.ecosystemIntegratorId}`;
          console.log('Fetching integrator from:', integratorUrl);
          const integratorResponse = await apiService.get(integratorUrl);
          console.log('Integrator response:', integratorResponse);

          // Handle different response formats
          let integratorName = 'Unknown';
          if (integratorResponse?.integratorName) {
            integratorName = integratorResponse.integratorName;
          } else if (integratorResponse?.data?.integratorName) {
            integratorName = integratorResponse.data.integratorName;
          } else if (integratorResponse?.name) {
            integratorName = integratorResponse.name;
          } else if (integratorResponse?.data?.name) {
            integratorName = integratorResponse.data.name;
          }

          console.log(`Extracted name for integrator ${mapping.ecosystemIntegratorId}:`, integratorName);

          return {
            ...mapping,
            integratorName,
          };
        } catch (err) {
          console.error('Error fetching integrator:', err);
          return {
            ...mapping,
            integratorName: 'Unknown',
          };
        }
      })
    );

    console.log('Enriched integrators:', enrichedMappings);
    return enrichedMappings;
  } catch (error) {
    console.error('Error fetching linked integrators:', error);
    return [];
  }
};

export const unlinkCropFromIntegrator = async (cropId, integratorId) => {
  try {
    await apiService.delete(`${apiEndPoints.cropsCreateOrUpdate}/${cropId}/integrators/${integratorId}`);
    return { success: true };
  } catch (error) {
    return { success: false, message: error.message || 'Failed to unlink integrator' };
  }
};

export const getCropsByIntegrator = async (integratorId) => {
  try {
    const response = await apiService.get(`${apiEndPoints.cropsCreateOrUpdate}/by-integrator/${integratorId}`);
    if (Array.isArray(response)) return response;
    if (Array.isArray(response?.data)) return response.data;
    return [];
  } catch (error) {
    return [];
  }
};
